import Vue from 'vue';
import Vuex, { Store } from 'vuex';
import VuexPersist from 'vuex-persist';
/**
 * Global
 */
import RouteStore from './modules/route.store';
import ErrorStore from './modules/error';
import AuthStore from './modules/auth.store';
import ChangePassword from './modules/change-password.store';
import UfStore from './modules/uf.store';
/**
 * Revista Online
 */
import UserStore from './modules/Revista/user.store';
import HomeStore from './modules/Revista/home.store';
import BreadcrumbStore from './modules/Revista/breadcrumb.store';
import ModalStore from './modules/Revista/modal.store';
import NotificacoesStore from './modules/Revista/notificacoes.store';
import MenuStore from './modules/Revista/menu.store';
import BarraAcessoStore from './modules/Revista/barra-acesso.store';
import BarraLateralStore from './modules/Revista/barra-lateral.store';
import BaseCategoriaStore from './modules/Revista/base-categoria.store';
import BaseTagStore from './modules/Revista/base-tag.store';
import BasePostStore from './modules/Revista/base-post.store';
import BaseSeLigaStore from './modules/Revista/base-se-liga.store';
import InstrucaoTrabalhoStore from './modules/Revista/instrucao-trabalho.store';
import SearchStore from './modules/Revista/search.store';
import CategoriaStore from './modules/Revista/categoria.store';
import MidiaStore from './modules/Revista/midia.store';
import TrocaChipStore from './modules/Revista/trocaChip.store';
import RankingLojaStore from './modules/Revista/ranking-lojas.store';
import FavoritosStore from './modules/Revista/favoritos.store';
import ModalCopyStore from './modules/Revista/modal-copy.store';

/**
 * Vivo Consulta
 */
import VcUser from './modules/VivoConsuta/user.store';
import VcTabela from './modules/VivoConsuta/tabela.store';
import VcBusca from './modules/VivoConsuta/busca.store';
import VcDestaque from './modules/VivoConsuta/destaque.store';
import VcSlider from './modules/VivoConsuta/slider.store';
import VcSliderPlanos from './modules/VivoConsuta/planos-slider.store';
import vcModelo from './modules/VivoConsuta/modelo.store';
import vcPlano from './modules/VivoConsuta/planos.store';

Vue.use(Vuex);

const vuexPersist = new VuexPersist({
  key: 'revista-online',
  storage: window.localStorage,
  reducer: state => ({
    user: state.user,
    menu: state.menu,
    // categoria: state.categoria,
  }),
});

const vcPersist = new VuexPersist({
  key: '@vivo-consulta',
  storage: window.localStorage,
  reducer: state => ({
    uf: state.uf,
  }),
});

const store = new Store({
  modules: {
    /**
     * Global Use
     */
    apiRoute: RouteStore,
    auth: AuthStore,
    /**
     * O modulo "idle" e registrado pelo idle-vue em main.js (registerModule,
     * sem namespace). Declarar um aqui so criava um modulo que era substituido
     * na inicializacao -- e o getter "idle/status" que ele expunha deixava de
     * existir, quebrando em silencio quem dependia dele.
     */
    error: ErrorStore,
    uf: UfStore,
    user: UserStore,
    changePassword: ChangePassword,
    /**
     * Revista Online Stores
     */
    categoria: CategoriaStore,
    modal: ModalStore,
    notificacoes: NotificacoesStore,
    menu: MenuStore,
    breadcrumb: BreadcrumbStore,
    home: HomeStore,
    barraAcesso: BarraAcessoStore,
    barraLateral: BarraLateralStore,
    baseCategoria: BaseCategoriaStore,
    baseTag: BaseTagStore,
    basePost: BasePostStore,
    baseSeLiga: BaseSeLigaStore,
    it: InstrucaoTrabalhoStore,
    search: SearchStore,
    midia: MidiaStore,
    trocaChip: TrocaChipStore,
    rankingLoja: RankingLojaStore,
    favoritos: FavoritosStore,
    modalCopyStore: ModalCopyStore,
    /**
     * Vivo Consulta Stores
     */
    vcUser: VcUser,
    vcTabela: VcTabela,
    vcBusca: VcBusca,
    vcDestaque: VcDestaque,
    vcSlider: VcSlider,
    vcSliderPlanos: VcSliderPlanos,
    vcModelo: vcModelo,
    vcPlano: vcPlano,
  },
  plugins: [vuexPersist.plugin, vcPersist.plugin],
});

export default store;
